// extracted by mini-css-extract-plugin
export var cancelButton = "_kt-5";
export var content = "_kt-3";
export var createButton = "_kt-6";
export var drawerContainer = "_kt-0";
export var footer = "_kt-2";
export var header = "_kt-1";
export var orderFormColumn = "_kt-4";